import { UntypedFormGroup, UntypedFormControl, UntypedFormArray, Validators } from '@angular/forms';

import { PcgTableColumn } from '../../../table/pcg-table-column.interface';

// tslint:disable:quotemark
// tslint:disable:max-line-length
// tslint:disable:whitespace
export class EditLetterCodeVm {
	letterCodeId: number;
	letterCodeName?: string;

	static get FormData() {
		return this.getFormData();
	}

	static getFormData(validators = {}) {
		return {
			'letterCodeId': new UntypedFormControl(0, [...(validators['letterCodeId'] ?? []), ...[Validators.required]]),
			'letterCodeName': new UntypedFormControl(null, [...(validators['letterCodeName'] ?? []), ...[Validators.required, Validators.minLength(2), Validators.maxLength(100)]])
		};
	}

	static get Form() {
		return new UntypedFormGroup(this.FormData);
	}

	static GetModel(fg: UntypedFormGroup): EditLetterCodeVmFromFg {
		return new EditLetterCodeVmFromFg(fg);
	}
}

export class EditLetterCodeVmFromFg {
	constructor(public fg: UntypedFormGroup) { }


	get letterCodeId(): number {
		return this.fg.get('letterCodeId').value;
	}
	set letterCodeId(val) {
		this.fg.get('letterCodeId').setValue(val);
	}

	get letterCodeName(): string {
		return this.fg.get('letterCodeName').value;
	}
	set letterCodeName(val) {
		this.fg.get('letterCodeName').setValue(val);
	}
}
